






























































































































import Vue from 'vue'
import GoogleMyBusiness from '@/pmd/components/launchpad/GoogleMyBusiness.vue'
import FacebookBusiness from '@/pmd/components/launchpad/FacebookBusiness.vue'
import ChatWidget from '@/pmd/components/launchpad/ChatWidget.vue'
import ChatWidgetSetup from '@/pmd/components/launchpad/ChatWidgetSetup.vue'
import LeadConnector from '@/pmd/components/launchpad/LeadConnector.vue'
import BookAppointment from '@/pmd/components/launchpad/BookAppointment.vue'
import StripeConnect from '@/pmd/components/launchpad/StripeConnect.vue'
import AddUsers from '@/pmd/components/launchpad/AddUsers.vue'
import YextLaunchpadComponent from '@/pmd/components/launchpad/YextLaunchpadComponent.vue'
import WordpressLaunchpadComponent from '@/pmd/components/launchpad/WordpressLaunchpadComponent.vue'

import { mapState } from 'vuex'
import { Location, User, OAuth2, UserState, Company } from '@/models'
import defaults from '@/config'
import { trackGaEvent } from '@/util/helper'
import StepCompletedIcon from '@/assets/pmd/img/step-completed.svg'
import moment from 'moment-timezone'
import axios from 'axios'

export default Vue.extend({
  name: 'LocationLaunchpad',
  components: {
    GoogleMyBusiness,
    FacebookBusiness,
    ChatWidget,
    ChatWidgetSetup,
    LeadConnector,
    StepCompletedIcon,
    StripeConnect,
    AddUsers,
    YextLaunchpadComponent,
    WordpressLaunchpadComponent
  },
  data() {
    return {
      location: {} as Location,
      onboardingData: {},
      baseUrl: defaults.baseUrl,
      newOnboardingFrontend: defaults.newOnboardingFrontend,
      firstName: '',
      childLoaded: false,
      authKey: '',
      apiKey: '',
      modalName: '',
      googleConnections: [] as OAuth2[],
      googleLocations: [],
      currentLocationId: '',
      analyticsAccounts: [],
      adwordsCustomerIds: [],
      adwordsMCCIds: [],
      selectedMCCId: '',
      analyticsViews: [],
      isUpdating: false,
      isFirstFetch: true,
      isComponentReq: true,
      facebookPages: [],
      cmsName: '',
      cmsSelection: false,
      gmbPageName: '',
      appLoader: false,
      websiteScreenshot: undefined,
      sendInstruction: false,
      chatWidgetSetup: 0,
      analyticsAcc: '',
      googleBusinessAccount: '',
      sending: false,
      slideShow: false,
      disableAction: false,
      active: 'google',
      showChatWidgetSetup: false,
      showMobileAppError: false,
      shortenUrlMobileApp: '',
      isChatWidgetConnected: false,
      reconnect: false,
      website: '',
      chatWidgetChecking: false,
      mobileAppChecking: false,
      isLeadConnectorConnected: false,
      hideLaunchpadDate: undefined,
      wlIds: [],
      chatWidgetInterval: undefined,
    }
  },
  watch: {
    '$route.params.location_id': async function (id) {
      this.currentLocationId = id
      await this.fetchData()
    },
  },
  async created() {
    this.currentLocationId = this.$router.currentRoute.params.location_id
    if (this.currentLocationId) {
      await this.fetchData()
    }
    const wlAppAgencies = this.remoteConfig.getString('wl_app_agencies')
    if (wlAppAgencies) {
      this.wlIds = wlAppAgencies.split(',')
    }
  },
  async mounted() {
    if (this.user) {
      //this.loadMicroApp()
      this.childLoaded = true
    }
    this.$root.$on('close-modal', () => {
      if (this.modalName == 'chat-widget') this.closeChatModal()
      this.modalName = ''
    })
    /* Facebook Event listener */
    this.$root.$on('show-select-cms', () => {
      this.cmsSelection = true
    })
    this.$root.$on('cms-change', (data: string) => {
      this.cmsSelection = false
      this.cmsName = data
    })
    this.$root.$on('send-instruction', () => {
      this.cmsSelection = false
      this.sendInstruction = true
    })
    this.$root.$on('show-loader', () => {
      this.showHideLoader()
    })
    this.$root.$on('hide-loader', () => {
      this.showHideLoader()
    })
    this.$root.$on('disable-launchpad-action', (data: string) => {
      const actionData = JSON.parse(data)
      this.disableAction = actionData.disable
      this.active = actionData.action
    })
    this.$root.$on('get-screenshot', () => {
      this.getScreenshot()
    })
    this.$root.$on('detected-cms', cms => {
      this.cmsName = cms
      this.showChatWidgetSetup = true
    })
    this.$root.$on('hide-widget-setup', () => {
      this.showChatWidgetSetup = false
      this.websiteScreenshot = undefined
      this.isLaunchpadCompleted(true)
    })
    this.$root.$on('chat-integrated', () => {
      this.showChatWidgetSetup = false
      this.isLaunchpadCompleted(true)
    })
    trackGaEvent(
      'Launchpad',
      'Landed on launchpad',
      `User landed on launchpad for location: ${this.currentLocationId}`
    )
    if (this.$route.query.mobile_app_error) {
      await this.getMobileAppShortenedUrl()
      this.showMobileAppError = true
      this.$router.replace({ query: undefined })
    }
    this.$root.$on('hide-mobile-error', () => {
      this.showMobileAppError = false
    })
    this.$root.$on('launchpad-status', async () => {
      this.location = new Location(
        await this.$store.dispatch(
          'locations/getCurrentLocation',
          this.currentLocationId
        )
      )
      this.isLaunchpadCompleted(false)
    })
  },
  computed: {
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
    adminOrOwnerOfGoogleIntegration() {
      // If the field doesn't exists any user should be able to edit the pages.
      if (!this.googleConnection || !this.googleConnection.ownerId) return true
      if (this.user.isAdmin) return true
      return this.googleConnection.ownerId === this.user?.id
    },
    googleConnection() {
      return this.googleConnections.find(
        x => x.id === this.location.primaryGoogleConnectionId
      )
    },
    isSupport() {
      return Boolean(this.$route.query.support === 'true')
    },
    hasSettingsPermission() {
      // In general admin level users do have this permission despite the role type
      return this.user.permissions.settings_enabled
    },
    hasAppointmentsPermission() {
      return this.user.permissions.appointments_enabled
    },
    filteredGoogleConnections() {
      return this.user.role === 'admin' || this.hasSettingsPermission
        ? this.googleConnections
        : this.googleConnections.filter(x => x.users && this.user.id in x.users)
    },
    isGMBConnected(): boolean | undefined {
      return this.location.gmb?.name ? true : false
    },
    isFbConnected(): boolean | undefined {
      return this.location.facebookPageId || this.location.fbTokenExpired
        ? true
        : false
    },
    isStripeConnected() {
      return this.$store.state.stripeConnect.accountId
    },
    isWhitLabelAppEnabled() {
      return this.wlIds.includes(this.company.id) && !this.company?.whitelabelAppLinks?.android
    },
    isAdmin() {
      return this.user.role == User.ROLE_ADMIN
    },
  },
  methods: {
    async fetchData() {
      let _self = this
      if (this.currentLocationId) {
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
      }
      this.isLaunchpadCompleted(true)
    },
    showHideLoader() {
      const element = document.getElementById('app')
      const htmlTag = document.getElementsByTagName('html')[0]
      if (!this.appLoader && element && htmlTag ) {
        this.$store.commit('setAgencyLoaderState',true)

        htmlTag.className = 'overflow-hidden lead-connector'
      } else if (element && htmlTag) {
        // element.className = ''
        htmlTag.className = ''
        this.$store.commit('setAgencyLoaderState',false)
      }
      this.appLoader = !this.appLoader
    },
    async getScreenshot() {
      try {
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
        const response = await axios.get(
          `${defaults.cloudFunctionsUrl}/websitescreenshot?website=${this.location.website}`
        )
        this.websiteScreenshot = response.data
      } catch (err) {
        console.log(err)
      }
    },
    closeChatModal() {
      this.sendInstruction = false
      this.cmsSelection = false
    },
    async getMobileAppShortenedUrl() {
      try {
        const domain = window.location.origin
        const appLink = `${domain}/login/token?token=${
          this.user.token
        }&url=${encodeURIComponent(
          `/location/${this.currentLocationId}/mobile_app_links`
        )}`
        const response = await this.$http.post('url/shorten', {
          originalUrl: appLink,
        })
        if (response.status == 200) {
          this.shortenUrlMobileApp = response.data.shortUrl
        }
      } catch (error) {
        console.log(error)
      }
    },
    async isLaunchpadCompleted(api: boolean) {
      try {
        let launchpadCompleted = true
        let updateRequire = true
        let locationUpdate = {}
        let launchpad = {}
        if (api) {
          const response = await Promise.all([
            this.isChatWidgetIntegrated(),
            this.isMobileAppInstalled(),
          ])
          locationUpdate = {
            ...response[0],
            ...response[1],
            is_stripe_connected: this.isStripeConnected ? true : false,
          }
          if (this.location.launchpad) {
            updateRequire = false
            launchpad = this.location.launchpad
            for (const prop in locationUpdate) {
              if (
                (this.location.launchpad[prop] &&
                  this.location.launchpad[prop] != locationUpdate[prop]) ||
                !this.location.launchpad[prop]
              ) {
                updateRequire = true
                launchpad[prop] = locationUpdate[prop]
              }
            }
          }
          if (updateRequire) {
            await this.location.ref.update({
              launchpad: launchpad,
            })
            this.location = new Location(
              await this.$store.dispatch(
                'locations/getCurrentLocation',
                this.currentLocationId
              )
            )
          }
        }
        if (
          !this.isGMBConnected ||
          !this.isFbConnected ||
          !this.isChatWidgetConnected ||
          (!this.isLeadConnectorConnected && !this.isWhitLabelAppEnabled) ||
          !this.isStripeConnected
        ) {
          launchpadCompleted = false
          trackGaEvent(
            'Launchpad',
            'Launchpad not completed',
            `All integrations not yet completed for location: ${this.currentLocationId}`
          )
        }
        if (this.user.type === 'account') {
          let launchpadCompletedDate = this.user?.launchpadCompletedDate
          let updateUser = false
          if (!launchpadCompleted && launchpadCompletedDate) {
            launchpadCompletedDate = undefined
            updateUser = true
          } else if (launchpadCompleted && !launchpadCompletedDate) {
            launchpadCompletedDate = moment().add(1, 'days')
            updateUser = true
          }
          if (updateUser) {
            const user = await User.getById(this.user.id)
            user.launchpadCompletedDate = launchpadCompletedDate
            await user.save()
            if (launchpadCompletedDate) {
              trackGaEvent(
                'Launchpad',
                'Launchpad completed',
                `All integrations has benn completed for location: ${this.currentLocationId}`
              )
            }
          }
          if (this.user?.launchpadCompletedDate) {
            this.hideLaunchpadDate = this.user.launchpadCompletedDate.format(
              'ddd, Do MMM YYYY'
            )
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async isChatWidgetIntegrated() {
      let reconnect = this.location.launchpad?.is_chat_widget_disconnected
        ? true
        : false
      this.isChatWidgetConnected = this.location.launchpad
        ?.is_chat_widget_integrated
        ? true
        : false
      let website = this.location.launchpad?.website
        ? this.location.launchpad?.website
        : ''
      if (this.location.website && this.location.website != website) {
        website = this.location.website
      }
      await this.setChatWidgetStatus(website)

      return {
        is_chat_widget_disconnected: reconnect,
        is_chat_widget_integrated: this.isChatWidgetConnected,
        website: website,
      }
    },
    setChatWidgetStatus(website: string) {
      return new Promise(async(resolve, reject) => {
        try {
          if (website) {
            this.chatWidgetChecking = true
            const response = await axios.get(
              `${defaults.cloudFunctionsUrl}/isChatWidgetIntegrated?website=${website}`
            )
            this.isChatWidgetConnected = false
            if (response.status == 200) {
              this.isChatWidgetConnected = response.data.is_chat_integrated
            }
            this.chatWidgetChecking = false
          }
        } catch (err) {
          this.chatWidgetChecking = false
          this.isChatWidgetConnected = false
        }

        if (
          !this.isChatWidgetConnected &&
          (this.location.launchpad?.is_chat_widget_integrated ||
            this.location.launchpad?.is_chat_widget_disconnected)
        ) {
          this.reconnect = true
        } else {
          this.reconnect = false
        }
        if (this.isChatWidgetConnected) {
          trackGaEvent(
            'Launchpad',
            'WebChat Widget Integrated',
            `WebChat Widget has been integrated for location: ${this.currentLocationId}`
          )
        }
      })
    },
    async isMobileAppInstalled() {
      this.mobileAppChecking = true
      try {
        if (!this.user.launchpad?.is_mobile_app_installed) {
          const response = await this.$http.post('/mobile/is_app_installed', {
            location_id: this.currentLocationId,
          })
          if (response.status == 200) {
            this.isLeadConnectorConnected =
              response.data.is_mobile_app_installed
          }
        } else if (this.location.launchpad?.is_mobile_app_installed) {
          this.isLeadConnectorConnected = this.location.launchpad?.is_mobile_app_installed
        }
        if (this.isLeadConnectorConnected) {
          trackGaEvent(
            'Launchpad',
            'Mobile App Installed',
            `Mobile App has been installed for location: ${this.currentLocationId}`
          )
        }
      } catch (err) {
        console.log(err)
      }
      this.mobileAppChecking = false
      return {
        is_mobile_app_installed: this.isLeadConnectorConnected,
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('popstate', () => console.log('remove popstate'))
  },
})
